//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import gsap from "gsap";

let positions = [];
for (let i = 0; i < 30; i++) {
  positions.push({
    x: gsap.utils.mapRange(0, 1, -3, 3, Math.random()),
    y: gsap.utils.mapRange(0, 1, -3, 3, Math.random()),
  });
}

export default {
  name: "project",
  components: {},
  data() {
    return {
      data: null,
      numMedia: 0,
      activeIndex: 0,
      info: null,
      spacingX: 0,
      spacingY: 0,
      canvasRatio: 1,
      positions: positions,
      previousProject: null,
      nextProject: null,
    };
  },
  methods: {
    goToProject(item) {
      this.$router.push({
        path: `/projects/${item.slug}`,
      });
    },
    resize() {
      if (this.$refs["gallery"]) {
        const gallery = this.$refs["gallery"].getBoundingClientRect();
        this.canvasRatio = gallery.width / gallery.height;
      }
    },
    maxWidth(item) {
      let value = "auto";
      if (item.ratio > this.canvasRatio) {
        value = `80%`;
      }
      return value;
    },
    maxHeight(item) {
      let value = "auto";
      if (item.ratio < this.canvasRatio) {
        value = `80%`;
      }
      return value;
    },
    prevIndex() {
      // this.activeIndex = this.activeIndex === 0 ? 0 : this.activeIndex - 1;
      if (this.activeIndex > 0) {
        this.activeIndex--;
      }
    },
    nextIndex() {
      if (this.activeIndex < this.numMedia - 1) {
        this.activeIndex++;
      }
    },
    keydown(event) {
      if (event.keyCode === 38) {
        this.goToProject(this.previousProject);
      }
      if (event.keyCode === 40) {
        this.goToProject(this.nextProject);
      }

      if (event.keyCode === 37) {
        this.prevIndex();
      }
      if (event.keyCode === 39) {
        this.nextIndex();
      }
    },
    embedVideo(event, data) {
      event.preventDefault();
      event.stopPropagation();
      const provider = data.provider_name.toLowerCase();
      if (provider === "vimeo") {
        event.target.parentNode.innerHTML = `<iframe src=\"https://player.vimeo.com/video/${data.video_id}?h=93064e01df&amp;app_id=122963&amp;autoplay=1\" frameborder=\"0\" allow=\"autoplay; fullscreen; picture-in-picture\" allowfullscreen title=\"${this.data.title[0].text}\" ></iframe>`;
      } else {
        const embedURL = data.embed_url;
        const start = data.embed_url.indexOf("?v=") + 3;
        const embedID = data.embed_url.slice(start);
        event.target.parentNode.innerHTML = `<iframe style="width: 100%; height:100%;" src="https://www.youtube.com/embed/${embedID}?feature=oembed&autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      }
    },
  },
  computed: {
    activeMediaIndex() {
      return this.$store.state.activeMediaIndex;
    },
  },
  watch: {
    positions(newValue) {},
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keydown);
    window.removeEventListener("resize", this.resize);
  },
  head() {
    return {
      title: `${this.$store.state.appTitle} ${this.$store.state.appTitleDivider} ${this.data.title[0].text}`,

      meta: [
        {
          hid: "og:image",
          property: "og:image",
          content: this.ogImage,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: `${this.$store.state.appTitle} ${this.$store.state.appTitleDivider} ${this.data.title[0].text}`,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: `${this.meta_description}`,
        },
        {
          hid: "description",
          name: "description",
          content: `${this.meta_description}`,
        },
        {
          hid: "og:site_name",
          property: "og:site_name",
          content: `${this.$store.state.appTitle}`,
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `https://lassekorsgaard.com/projects/${this.slug}`,
        },
      ],
    };
  },
  mounted() {
    this.numMedia = this.data.media.length;

    // console.log(this.$store.state.projects);

    const index = this.$store.state.projects.findIndex(
      (project) => project.data.title[0].text === this.data.title[0].text
    );

    const nextIndex =
      index === this.$store.state.projects.length - 1 ? 0 : index + 1;
    const prevIndex =
      index === 0 ? this.$store.state.projects.length - 1 : index - 1;

    this.previousProject = this.$store.state.projects[prevIndex];
    this.nextProject = this.$store.state.projects[nextIndex];

    this.resize();
    window.addEventListener("resize", this.resize);
    window.addEventListener("keydown", this.keydown);

    this.$ga.page(this.$router);
  },
  async asyncData({ $prismic, params, error, store }) {
    try {
      let data = (await $prismic.api.getByUID("project", params.uid)).data;

      // const info = params.uid;

      data.media = data.media.filter(
        (item) =>
          item.type === "image" ||
          item.type === "embed" ||
          item.type === "local_video"
      );

      data.media = data.media.map((item) => {
        if (item.type === "image") {
          item.width = item.image.dimensions.width;
          item.height = item.image.dimensions.height;
          item.ratio = item.width / item.height;
        }

        if (item.type === "local_video") {
          // item.width = item.image.dimensions.width;
          // item.height = item.image.dimensions.height;
          item.ratio = item.code_ratio || 1.7778;
        }

        if (item.type === "embed") {
          if (item.embed.provider_name === "Vimeo") {
            // item.embed.thumbnail_url =
            const old = item.embed.thumbnail_url;
            // /\_[\d]+x[\d]+
            let newThumbnailUrl = old.replace(/\_[\d]+[x][\d]+/gm, "_800");

            item.embed.thumbnail_url = newThumbnailUrl;
          }
          item.width = item.embed.width;
          item.height = item.embed.height;
          item.ratio = item.width / item.height;
        }

        return item;
      });

      return {
        // info,
        slug: params.uid,
        data,
        ogImage: data.featured_image.big.url,
        meta_description: data.meta_description,
      };
    } catch (error) {}
  },
};
